import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import GrayscaleImage from '../../components/GrayscaleImage';

const GrayscalePage: React.FC = () => (
  <ToolLayout
    title="Convert Image to Grayscale - Black & White | AllTools"
    description="Convert color images to grayscale/black and white online. Free image to grayscale converter."
    canonicalPath="/grayscale-image"
  >
    <GrayscaleImage />
  </ToolLayout>
);

export default GrayscalePage;
